module.exports = __webpack_public_path__ + "img/kanako yasaka_sc1.7553e6bb.png";